export default {
    resolveMimeToFileEnding(mime)
    {
        switch(mime) {
            case 'application/pdf':
                return '.pdf';
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return '.docx';
            case 'application/msword':
                return '.doc';
        }

        return '';
    },
    cutBase64ApplicationData(base64_String)
    {
        let splittedString = base64_String.split(',');

        return splittedString[1];
    },
    readFileAsync(file)
    {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }
}